import React from "react";
import "../Section.css";
import "./About.css";

function About() {
  return (
    <section id="AboutSection">
      <h1>About</h1>
      <div className="about-text">
        <p>
          Hello there! I'm Randy Huynh, a software engineer in the making, with roots in mechanical studies. My fascination with the mechanics of things traces back to my days spent engrossed in Discovery Channel programs. Shows like MythBusters and How It's Made sparked my curiosity about how individual components come together to create intricate systems that yield final products. This early interest laid the foundation for my career path, where I began my professional journey at Walk With Web Inc. (WWW), a forward-thinking Canadian company at the intersection of technology and social sciences. My role at WWW was my first professional experience with full-stack development, I was personally responsible for creating a web app as well as contributing to the design of the database schemas. This role allowed me to play a key part in developing and upkeeping digital platforms, thereby enhancing the accessibility and longevity of research initiatives.
        </p>
        <p>
          But let's rewind a bit. I'm a proud alum of York University, where I
          studied Computer Engineering. In hindsight, Computer Science would
          have been more aligned with my interests, especially considering the
          Comp Sci-based electives were the only ones I was really interested
          in. During my time there, I not only honed my coding skills but also
          developed a keen interest in software systems design. This was largely
          inspired by my role as a Computer Support Assistant. In this position,
          I encountered firsthand the challenges users face with poorly designed
          software. These experiences highlighted the importance of creating
          intuitive and efficient software solutions.
        </p>
        <p>
          When I'm not immersed in the world of software development, you'll
          find me engaged in the competitive world of gaming. I've been a gamer
          since 2000, starting with my first console, the Game Boy Color. These
          days, my go-to FPS games are Apex Legends and The Finals, where I
          thrive on the adrenaline and strategy. But my gaming interests are
          diverse, ranging from the immersive worlds of Final Fantasy 7 and the
          Yakuza Franchise to the charming realms of Stardew Valley and the
          recent favorite, Pal World.
        </p>
        <p>
          Living in the dynamic city of Toronto, I've embraced an active
          lifestyle to keep up with the city's pace. Fitness has become an
          integral part of my routine, helping me stay energized and focused.
        </p>
      </div>
    </section>
  );
}

export default About;
